export default "__VITE_ASSET__BeHNw$jf__"